import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'antd/dist/reset.css';
import { App } from './App';
import './styles.css';

const el = document.getElementById('products-root');
if (el) {
    createRoot(el).render(
        <StrictMode>
            <App userId={el.dataset.userId} csrf={el.dataset.csrf} />
        </StrictMode>,
    );
}
